// used to import the global webpack public path exported in the
// head of the doc into the bundle so that webpack can pick it up
// see https://webpack.js.org/guides/public-path/#on-the-fly

// eslint-disable-next-line ssr-friendly/no-dom-globals-in-module-scope
if (typeof window !== 'undefined' && window.__webpack_public_path__) {
  // eslint-disable-next-line
  __webpack_public_path__ = window.__webpack_public_path__;
}
